import { combineReducers } from "redux";
import commonReducer from "./commonReducer";
import authReducer from "./authReducer";
import customerReducer from "./customerReducer";
import sancharReducer from "./sancharReducer";
import rechargeReducer from "./rechargeReducer";
import ecommerceReducer from "./ecommerceReducer";
import milansathiReducer from "./milansathiReducer";
import staticpageReducer from "./staticpageReducer";

const rootReducer = combineReducers({
    commonReducer,
    authReducer,
    customerReducer,
    sancharReducer,
    rechargeReducer,
    ecommerceReducer,
    milansathiReducer,
    staticpageReducer
});

export default rootReducer;